import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Men from './pages/Men';
import Women from './pages/Women';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BeautynSkincare from './pages/BeautynSkincare';
import Fabrics from './pages/Fabrics';
import Accessories from './pages/Accessory';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div><Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/men" element={<Men />} />
        <Route path="/women" element={<Women />} />
        <Route path="/kids" element={<Men />} />
        <Route path="/fabrics" element={<Fabrics />} />
        <Route path="/skincare" element={<BeautynSkincare />} />
        <Route path="/accessories" element={<Accessories />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/confirmation/:id" element={<OrderConfirmation />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      
    </Router>
    <Footer />
    </div>
  );
}

export default App;
